import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { PromiseSection } from '../components/sections/PromiseSection';
import { MechanismSection } from '../components/sections/MechanismSection';
import { FilterSection } from '../components/sections/FilterSection';
import { OfferStackSection } from '../components/sections/OfferStackSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { PricingSection } from '../components/sections/PricingSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { StickyMobileCTA } from '../components/ui/StickyMobileCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-bg-primary text-text-primary font-body selection:bg-cta-primary selection:text-cta-text" data-id="element-290">
      <HeroSection data-id="element-291" />
      <ProblemSection data-id="element-292" />
      <PromiseSection data-id="element-293" />
      <MechanismSection data-id="element-294" />
      <FilterSection data-id="element-295" />
      <OfferStackSection data-id="element-296" />
      <TestimonialsSection data-id="element-297" />
      <HowItWorksSection data-id="element-298" />
      <GuaranteeSection data-id="element-299" />
      <PricingSection data-id="element-300" />
      <FAQSection data-id="element-301" />
      <FinalCTASection data-id="element-302" />

      {/* Footer simple */}
      <footer className="py-8 text-center text-text-secondary text-sm bg-bg-primary border-t border-border-color" data-id="element-303">
        <p data-id="element-304">
          © {new Date().getFullYear()} El Método Magnético. Todos los derechos
          reservados.
        </p>
      </footer>

      <StickyMobileCTA data-id="element-305" />
    </div>;
}